import { LendingReturnPackageVolumeWeekdayHeatmapChart, hasChartSeries } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { useInsightHeatmapCellClick } from '../../../analytics/insights/heatmap-cell-summary/use-insight-heatmap-cell-click';
import { StatisticsCard } from '../../shared';
import { useLast6MonthsLendingReturnPackageVolumeWeekdayHeatmapChart } from './use-last-6-months-lending-return-package-volume-weekday-heatmap-chart';

export interface Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChartProps {
    accountId: string;
}

export const Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChart = (props: Last6MonthsLendingReturnPackageVolumeWeekdayHeatmapChartProps) => {
    const { data, isLoading, rangeStart, weekCount } = useLast6MonthsLendingReturnPackageVolumeWeekdayHeatmapChart(props);
    const title = (
        <FormattedMessage
            id='platform.statistics.lending.last-6-months-lending-return-package-volume-weekday-heatmap-chart.title'
            description='Title of the lending heatmap showing drop-off return package volume by weekday over the last six months'
            defaultMessage='Drop-off heatmap'
        />
    );
    const onCellClick = useInsightHeatmapCellClick({
        accountId: props.accountId,
        chartKey: LendingReturnPackageVolumeWeekdayHeatmapChart.definition.key,
        title
    });

    return (
        <StatisticsCard
            chartKey={LendingReturnPackageVolumeWeekdayHeatmapChart.definition.key}
            title={title}
            subtitle={
                <FormattedMessage
                    id='platform.statistics.lending.last-6-months-lending-return-package-volume-weekday-heatmap-chart.subtitle'
                    description='Subtitle on the lending drop-off heatmap indicating the chart covers the last six months'
                    defaultMessage='last 6 months'
                />
            }
            isLoading={isLoading}
            hasData={hasChartSeries(data)}>
            {hasChartSeries(data) && data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <LendingReturnPackageVolumeWeekdayHeatmapChart
                        data={data}
                        rangeStart={rangeStart}
                        weekCount={weekCount}
                        minHeight={220}
                        onCellClick={onCellClick}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
